/**
 * Utilitários de popover — mesmo modelo do ToolbarFilterChipDropdown (Board).
 */

import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { computeToolbarFilterPopoverLayout } from '../../board/board-search-filters/toolbarFilterPopoverLayout';

export function buildEcFilterPopoverStyle(layout) {
  if (!layout) return null;
  return {
    position: layout.position,
    top: layout.top,
    left: layout.left,
    width: layout.width,
    boxSizing: layout.boxSizing,
    zIndex: layout.zIndex,
    maxHeight: layout.maxHeight,
    '--bsf-cidade-popover-max-h': layout['--bsf-cidade-popover-max-h'],
    transform: layout.flipped ? 'translateY(-100%)' : undefined,
  };
}

export function useEcFilterPopoverLayout(anchorRef, isOpen, width = 238, maxHeight = 320) {
  const [layout, setLayout] = useState(null);

  const updateLayout = useCallback(() => {
    const el = anchorRef.current;
    if (!el || !isOpen) {
      setLayout(null);
      return;
    }
    const rect = el.getBoundingClientRect();
    setLayout(computeToolbarFilterPopoverLayout(rect, width, maxHeight));
  }, [anchorRef, isOpen, width, maxHeight]);

  useLayoutEffect(() => {
    updateLayout();
  }, [updateLayout, isOpen]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onResize = () => updateLayout();
    window.addEventListener('resize', onResize);
    window.addEventListener('scroll', onResize, true);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('scroll', onResize, true);
    };
  }, [isOpen, updateLayout]);

  return layout;
}

export const EC_FILTER_POPOVER_CLASS =
  'board-search-filters-popover board-search-filters-popover--simple board-search-filters-popover--tecnico ec-module-popover';
